import {Dto} from '../../../../common/src/lib/dtos/dto';
import {UnpackProtocolActivityRepMeasurementDto} from './unpackProtocolActivityRepMeasurementDto';

export class UnpackProtocolActivityRepDto extends Dto {
    activityCode: string;
    measurements: UnpackProtocolActivityRepMeasurementDto[];

    public deserialize(input: any): this {
        Object.assign(this, input);
        this.measurements = this.deserializeArray(input.measurements, UnpackProtocolActivityRepMeasurementDto);
        return this;
    }
}
